export default "__VITE_ASSET__lsybaB6n__"